export default __webpack_public_path__ + "static/media/GoogleDocsIcon.4420de62.svg";